<template>
  <BaseSlideOverModal
    v-model:is-modal-open="localOpen"
    width="xl"
    :title="''"
    @close="close"
  >
    <template #cta>
      <BaseButton
        :key="formButtonTitle"
        :title="formButtonTitle"
        icon="paper-plane"
        size="small"
        color="primary"
        @click="submitForm"
      />
    </template>
    <template #body>
      <div
        class="scrollbar-custom flex h-full w-full flex-col justify-between overflow-auto"
      >
        <SupplierOrderForm
          v-model:supplier-order="supplierOrder"
          :account-diaries="accountDiaries"
        />
      </div>
    </template>
  </BaseSlideOverModal>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DocTypes, InvoiceableType } from '@/assets/enums'
import moment from 'moment'
import SupplierOrderForm from '@ui/modal/supplierOrder/components/SupplierOrderForm'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'

export default {
  name: 'SupplierOrderModal',
  components: { BaseSlideOverModal, BaseButton, SupplierOrderForm },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    supplierId: {
      type: [String, Number],
      required: false,
      default: null
    },
    item: {
      type: Object,
      required: false,
      default: null
    },
    dossier: {
      type: Object,
      required: false,
      default: null
    },
    supplierOrderId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  emits: [
    'close',
    'update:modelValue',
    'change',
    'fetch-supplier-orders',
    'update:open'
  ],
  data() {
    return {
      supplierOrder: null,
      selectedSupplierOrderId: null,
      needToFetch: true,
      DocTypes: DocTypes,
      orderType: null,
      InvoiceableType: InvoiceableType,
      accountDiaries: []
    }
  },
  computed: {
    ...mapGetters({
      initialMetadata: 'metadata/getInitialMetadata',
      dossier: 'dossier/getDossier'
    }),
    localOpen: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    },
    formButtonTitle() {
      if (!this.supplierOrder) return null
      if (this.supplierOrder.recipient_type === InvoiceableType.SUPPLIER) {
        return this.supplierOrder.id
          ? this.$t('button.update_supplier_order')
          : this.$t('button.save_supplier_order')
      }
      if (this.supplierOrder.recipient_type === InvoiceableType.COMPANY) {
        return this.supplierOrder.id
          ? this.$t('button.update_company_order')
          : this.$t('button.save_company_order')
      }
      return this.$t('button.save_new_order')
    }
  },
  watch: {
    open(newValue, oldValue) {
      if (newValue !== oldValue && newValue) {
        this.fetchSupplierOrder()
      }
    }
  },
  methods: {
    ...mapActions({
      processStoreSupplierOrderAction: 'supplierOrder/storeSupplierOrder',
      processUpdateSupplierOrderAction: 'supplierOrder/updateSupplierOrder',
      processFetchSupplierOrderByIDAction:
        'supplierOrder/fetchSupplierOrderByID',
      processFetchNewSupplierOrderAction: 'supplierOrder/fetchNewSupplierOrder',
      processFetchAddressesByDossier: 'dossier/fetchAddressesByDossier'
    }),
    fetchSupplierOrder() {
      if (this.supplierOrderId) {
        this.processFetchSupplierOrderByIDAction({
          id: this.supplierOrderId
        }).then((response) => {
          this.supplierOrder = response.supplier_order
          this.accountDiaries = response.metadata.account_diaries
        })
      } else {
        this.processFetchNewSupplierOrderAction().then((response) => {
          this.supplierOrder = response.supplierOrder
          this.accountDiaries = response.metadata.account_diaries
        })
      }
    },
    submitForm() {
      if (this.supplierOrder?.id) {
        this.processUpdateSupplierOrderAction({
          supplier_order_id: this.supplierOrder.id,
          supplier_order: this.supplierOrder
        }).then((response) => {
          this.$h.toastSuccess(this.$t('toasts.supplier_order_updated'))
          this.$emit('fetch-supplier-orders')
          this.localOpen = false
        })
      } else {
        this.supplierOrder.emission_date = moment().format()
        this.processStoreSupplierOrderAction({
          supplier_order: this.supplierOrder
        }).then((response) => {
          this.$h.toastSuccess(this.$t('toasts.supplier_order_created'))
          this.$emit('fetch-supplier-orders')
          this.localOpen = false
        })
      }
    },
    handleEditSupplierOrder(supplier_order) {
      this.processSetSupplierOrderMutation(supplier_order)
      this.selectedSupplierOrderId = supplier_order?.id
    },
    handleCreateSupplierOrderButton() {
      this.needToFetch = true
      this.selectedSupplierOrderId = null
    }
  }
}
</script>
